import React from 'react';

import { Section, Grid } from '@gogame/components';
import { withForm, FormField, SidePageV2 } from '@gogame/form';

import { loadPartnerAudiences } from 'scenes/CustomAudiences/PartnerAudiences/sources/fields';
import { loadUnusedAccountsPartnerAudience } from 'scenes/CustomAudiences/PartnerAudiences/sources/sharedAccounts';

import { PARTNER_AUDIENCE, SHARE_ACCOUNTS } from './constants';
import { validationSchema } from './schemas';

export default withForm({ validationSchema: validationSchema })(
  ({ loading, onClose, onExited, open }) => {
    return (
      <SidePageV2
        onClose={onClose}
        onExited={onExited}
        loading={loading}
        open={open}
      >
        <SidePageV2.Title title={'Share Partner Audience'} />
        <SidePageV2.Content>
          <Section>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormField.Const
                  label={'Partner Audience'}
                  source={loadPartnerAudiences}
                  name={PARTNER_AUDIENCE}
                  padding={0}
                />
              </Grid>
              <Grid item xs={12}>
                <FormField.MultiSelect
                  label={'Share to accounts'}
                  placeholder={'Select accounts'}
                  source={loadUnusedAccountsPartnerAudience}
                  depends={[PARTNER_AUDIENCE]}
                  name={SHARE_ACCOUNTS}
                  padding={0}
                />
              </Grid>
            </Grid>
          </Section>
        </SidePageV2.Content>
        <SidePageV2.Actions>
          <SidePageV2.CloseButton />
          <SidePageV2.SubmitButton>Share</SidePageV2.SubmitButton>
        </SidePageV2.Actions>
      </SidePageV2>
    );
  }
);
